import _ from 'lodash'
import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

import {isClient} from 'src/common/razzle-platform-components/utils'


// we use this code in the client because we need it only on browser (server does't have localstorage)
// we use this only for store and get object or array because we apply the char converter for them

if (isClient) {
    /**
     *
     * @param key string
     * @param value object or array
     */
    Storage.prototype.setObjectItem = function(key: string, value: Object | Array<unknown>) {
        if (_.isArray(value) || _.isObject(value)) {
            this.setItem(key, JSON.stringify(snakecaseKeys(value)))
        } else {
            throw new Error('setObjectItem accept only object or array value')
        }
    }

    /**
     *
     * @param key string
     * @returns object or array or null
     */
    Storage.prototype.getObjectItem = function(key: string): Object | Array<unknown> | null {
        return this.getItem(key) ? camelcaseKeys(JSON.parse(this.getItem(key)), {deep: true}) : null
    }

}
export {}

